import {
  SimplifiedStatusButton,
  StatusButton,
} from 'src/components/WalkThroughTable/statusButton';

const WalkthroughStatusView = ({
  data,
  propertyManagerDetails,
  renderActivate
}) => {
  const isSimplified = [
    'Simplified',
    'Developer Walk-through',
    'Construction Walk-through',
  ].includes(data.walkthroughType);

  if (isSimplified) {
    return (
      <SimplifiedStatusButton
        data={data}
        handleActivateWalkthrough={() => renderActivate(data)}
        propertyManagerDetails={propertyManagerDetails}
      />
    );
  }

  return (
    <StatusButton
      data={data}
      handleActivateWalkthrough={() => renderActivate(data)}
      propertyManagerDetails={propertyManagerDetails}
    />
  );
};

export default WalkthroughStatusView;